import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker } from 'antd';
import ButtonStyle from '../util/ButtonStyle';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import SearchClientPopup from "./SearchClientPopup";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';
registerLocale('ko', ko)

const { Option } = Select;
const { RangePicker } = DatePicker;

const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

const enrollConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '수강신청기간을 입력해 주세요!',
      },
    ],
};

const classConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '수강기간을 입력해 주세요!',
      },
    ],
};

function CouponPopup(props) {
    const [cid, setCid] = useState('');
    const [showSearch, setShowSearch] = useState(false);
    const [name, setName] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function toggleSearch() {
        setShowSearch(!showSearch)
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    function onInfoSubmit(name, cd) {
        setName(name);
        form.setFieldsValue({
            name: name,
            cd : cd
        });
    }

    const onFinish = (values) => {
        const { cid, cd, type, enroll_date, class_date, is_use, state } = values;
        let enroll_sdate = moment(enroll_date[0]).format('YYYY-MM-DD');
        let enroll_edate = moment(enroll_date[1]).format('YYYY-MM-DD');
        let class_sdate = moment(class_date[0]).format('YYYY-MM-DD');
        let class_edate = moment(class_date[1]).format('YYYY-MM-DD');

        if(props.mode === "add") {
            (async function () {
                const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
                const result = await axios.post(api_host + '/hg_admin/add_coupon', {
                    mcd : cd,
                    cid: cid,
                    type : type,
                    enroll_sdate : enroll_sdate,
                    enroll_edate : enroll_edate,
                    class_sdate : class_sdate,
                    class_edate : class_edate,
                    is_use : is_use,
                    state : state
                })
                if(result.data.ret == 'Y'){
                    alert('등록되었습니다');
                    props.closePopup("updated");
                }else{
                    alert(result.data.msg)
                }
            })();
        }else{
            (async function () {
                const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
                const result = await axios.post(api_host + '/hg_admin/edit_coupon', {
                    seq : props.data.seq,
                    cid : cid,
                    type : type,
                    enroll_sdate : enroll_sdate,
                    enroll_edate : enroll_edate,
                    class_sdate : class_sdate,
                    class_edate : class_edate,
                    is_use : is_use,
                    state : state
                })
                if(result.data.ret == 'Y'){
                    alert('수정되었습니다');
                    props.closePopup("updated");
                }else{
                    alert(result.data.msg)
                }
            })();
        }
    };

    async function deleteCoupon(seq) {
        const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
        const result = await axios.post(api_host + '/hg_admin/delete_coupon', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.name + "님의 쿠폰를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteCoupon(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        if(props.mode === "add"){
            setTitle("쿠폰 추가");
            form.setFieldsValue({
                type : 'weekly',
                is_use : 'N',
                state : 'Y'
            });
        }else if(props.mode === "edit"){
            setTitle("쿠폰 수정");
            setName(props.data.name);
            setCid(props.data.cid);
            let temp_enroll_sdate = props.data.enroll_date.substring(0,10);
            let temp_enroll_edate = props.data.enroll_date.substring(13,23);
            let temp_class_sdate = props.data.class_date.substring(0,10);
            let temp_class_edate = props.data.class_date.substring(13,23);
            let temp_enroll_date = [
                moment(temp_enroll_sdate),
                moment(temp_enroll_edate)
            ];
            let temp_class_date = [
                moment(temp_class_sdate),
                moment(temp_class_edate)
            ];
            form.setFieldsValue({
                name : props.data.name,
                cid : props.data.cid,
                enroll_date : temp_enroll_date,
                class_date : temp_class_date,
                type : props.data.type,
                is_use : props.data.is_use,
                state : props.data.state
            });
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
    },[]);

    return(
        <div className="popup">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="name"
                label="고객명"
                rules={[{ required: true, message: '고객명을 입력해 주세요.' }]}
            >
                {props.mode === 'add' ?
                <Input.Group>
                <Input.Search type="text" readOnly className="ant-input-readonly" onSearch={toggleSearch} value={name}/>
                </Input.Group>
                :
                <Input.Group>
                <Input type="text" readOnly value={name}/>
                </Input.Group>
                }
            </Form.Item>
            <Form.Item
                name="cid"
                label="센터명"
                rules={[{ required: true, message: '센터를 선택해 주세요.' }]}
            >
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/>
            </Form.Item>
            <Form.Item name="type" label="종류"
                rules={[{ required: true, message: '종류를 선택해 주세요.' }]}
            >
                <Radio.Group>
                <Radio value="weekly">weekly</Radio>
                <Radio value="super">super</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="enroll_date" label="수강신청기간" {...enrollConfig}>
                <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item name="class_date" label="수강기간" {...classConfig}>
                <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item name="is_use" label="사용" rules={[{ required: true, message: '사용여부를 선택해 주세요.' }]}>
                <Select>
                    <Option value="N">미사용</Option>
                    <Option value="Y">사용완료</Option>
                </Select>
            </Form.Item>
            <Form.Item name="state" label="상태" rules={[{ required: true, message: '상태를 선택해 주세요.' }]}>
                <Select>
                    <Option value="Y">Y</Option>
                    <Option value="N">N</Option>
                </Select>
            </Form.Item>
            <Form.Item name="cd" noStyle>
                <Input type="hidden" />
            </Form.Item>
            <Form.Item {...tailLayout}>
                {props.mode === "add" ? 
                    <Button type="primary" htmlType="submit">추가</Button>
                    :
                    <>
                    <Button type="primary" htmlType="submit">수정</Button>
                    &nbsp;
                    <Button type="danger" onClick={handleDelete}>삭제</Button>
                    </>
                }
            </Form.Item>
            </Form>
            
            {showSearch ? 
            <SearchClientPopup
                closePopup={toggleSearch}
                onSubmit = {onInfoSubmit}
                onlyClient
            />
            : null
            }
            </div>
            </Draggable>
        </div>
    )
}

export default CouponPopup;
